module.exports = "\n\n  <div class=\"statusbar animated fadeInDown d-flex justify-content-center\">\n    <div class=\"content p-2\">\n      <img src=\"assets/img/https.png\" alt=\"\" class=\"img-responsive text-center\" width=\"30\">\n      <img src=\"assets/img/verisign.jpg\" alt=\"\" class=\"img-responsive text-center\" width=\"60\">\n    </div>\n    <div class=\"content p-2\">\n      <img src=\"assets/img/verisign.jpg\" alt=\"\" class=\"img-responsive text-center\" width=\"60\">\n    </div>\n  </div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/ui/statusbar/statusbar.component.html
// module id = 1105
// module chunks = 0